import axios from "axios";

const API_BASE_URL = "http://103.186.133.119:5174/api/v1";

export const getYogaVideoByAccountId = async (accountId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/yogavideos/${accountId}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching yoga videos:", error);
        throw error;
    }
};

